// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/products/archive',
        component: () =>
            import('@/pages/[organisation]/inventory/products/archive.vue'),
        name: 'inventory.products.archived-products',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.product.update-product',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/products/archive/[id].vue'),
                name: 'inventory.products.view-archived-product',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.product.update-product',
                },
            },
        ],
    },
    {
        path: '/:organisation/inventory/stock-taking',
        component: () =>
            import('@/pages/[organisation]/inventory/stock-taking.vue'),
        name: 'inventory.products.stock-taking',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.product.update-product',
        },
    },
    {
        path: '/:organisation/inventory/products/import',
        component: () =>
            import('@/pages/[organisation]/inventory/products/import.vue'),
        name: 'inventory.products.import-products-csv',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.product.import-products-csv',
        },
    },
    {
        path: '/:organisation/inventory/products',
        component: () =>
            import('@/pages/[organisation]/inventory/products/index.vue'),
        name: 'inventory.products.search-products',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.product.view-products',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/products/new.vue'),
                name: 'inventory.products.create-product',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.product.create-product',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/products/[id].vue'),
                name: 'inventory.products.view-product',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.product.view-products',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/products/[id]/edit.vue'),
                name: 'inventory.products.update-product',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.product.update-product',
                },
            },
        ],
    },
];
